import './styles.scss';

/**
 * LightningHeroBenefit renders a single benefit item with an icon and description.
 *
 * @param {string} src — Image source URL for the default (mobile) benefit icon.
 * @param {string} lightningSrc — Image source URL for the desktop intro icon.
 * @param {string} alt — Alt text for the icon image.
 * @param {string} description — Localized benefit text.
 */
export const LightningHeroBenefit = ({ src, lightningSrc, alt, description }) => (
    <div className='lightning-hero-benefit'>
        <div className='lightning-hero-benefit__icon-wrap'>
            <img
                src={src}
                width={83}
                height={83}
                alt={alt}
                className='lightning-hero-benefit__icon-img'
            />
            <img
                src={lightningSrc}
                width={83}
                height={83}
                alt={alt}
                className='lightning-hero-benefit__icon-img lightning-hero-benefit__icon-img--lightning'
            />
        </div>
        <p className='lightning-hero-benefit__text'>{description}</p>
    </div>
);
